import { Tag, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faClock, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { QUOTATION_INSURANCE_CARRIER_STATE } from '@shared/constants/quotationInsuranceCarrierStates';

const { Text } = Typography;

const STATE_TAG_CONFIG = {
  [QUOTATION_INSURANCE_CARRIER_STATE.PENDING]: {
    icon: <FontAwesomeIcon icon={faClock} style={{ marginRight: 5 }} />,
    color: 'default',
  },
  [QUOTATION_INSURANCE_CARRIER_STATE.STARTED]: {
    icon: <LoadingOutlined spin />,
    color: 'cyan',
  },
  [QUOTATION_INSURANCE_CARRIER_STATE.PROCESSING]: {
    icon: <LoadingOutlined spin />,
    color: 'processing',
  },
  [QUOTATION_INSURANCE_CARRIER_STATE.SUCCEEDED]: {
    icon: <FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: 5 }} />,
    color: 'success',
  },
  [QUOTATION_INSURANCE_CARRIER_STATE.FAILED]: {
    icon: <FontAwesomeIcon icon={faTimesCircle} style={{ marginRight: 5 }} />,
    color: 'error',
  },
};

export const StateTag = ({ state }) => {
  if (!state) return null;

  const stateTagConfig = STATE_TAG_CONFIG[state] ?? {};

  return (
    <Tag
      bordered={false}
      icon={stateTagConfig.icon}
      color={stateTagConfig.color}
      style={{ borderRadius: 999 }}
    >
      <Text
        strong
        style={{
          color: 'inherit',
          fontSize: '0.9em',
          textTransform: 'uppercase',
        }}
      >
        {state}
      </Text>
    </Tag>
  );
};
